<template>
  <div>
    <el-row>
        <el-col :span="12">
            <div class="content">
                <div>下单数量</div>
                <div>{{orderInfo.order_count}}</div>
            </div>
        </el-col>
        <el-col :span="12">
            <div class="content">
                <div>下单总面积</div>
                <div>{{orderInfo.order_area.toFixed(2)}}</div>
            </div>
        </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    timer: null,
    orderInfo: {},
  }),
  methods: {
    getOrderData() {
      this.$axios.get("operation/order-data").then((res) => {
        console.log(res);
        this.orderInfo = res.data;
      });
    },
  },
  mounted() {
    this.getOrderData();
    this.timer = setInterval(() => {
      this.getOrderData();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器
    this.timer = null;
  },
};
</script>

<style lang="scss" scoped>
.content {
      background: #c5eafc;
      text-align: center;
      margin: 5px;
}
</style>